import React from "react";
import CommonModal from "./CommonModal";
import BookingForm from "../BookingForm";

const EditBookingModal = ({ isOpen, onClose, reservationId, onUpdated }) => {
  if (!reservationId) return null;

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="cmEditBookingModal">
      <div className="modal-header">
        <h5 className="modal-title">Edit Booking</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        ></button>
      </div>

      <div className="modal-body">
        <BookingForm
          reservationId={reservationId}
          onClose={onClose}
          onBookingSuccess={onUpdated}
        />
      </div>
    </CommonModal>
  );
};

export default EditBookingModal;
